<p>lib-product-none-tire-card works!</p>
